import React from 'react';

import Styles from './Header.module.scss';

const Header = (props: React.ComponentPropsWithRef<'div'>) => {
	return <div {...props} className={Styles.container}></div>;
};

export default Header;
